export default __webpack_public_path__ + "static/media/schedule-active.33789d44.svg";